// extracted by mini-css-extract-plugin
export default {"skeleton":"PageLoader_skeleton__foRY5","skeletonHero":"PageLoader_skeletonHero__Skujk","skeletonSection":"PageLoader_skeletonSection__RVnnq","shimmer":"PageLoader_shimmer__RKS2M"};